import React from "react";
import "./BybShipDelivery.css";
import HeaderNavbar from '../BybNavbar/HeaderNavbar'
import BybFooter from '../BybFooter/BybFooter'
function BybShipDelivery() {
  return (
    <>
                <HeaderNavbar/>

      <section className="byb-shipdelivery">
        <div className="container">
          <div className="byb-shipdelivery-header">
            <h4>Shipping and Delivery Policy</h4>
          </div>

          <div className="shipdelivery-content">
            <h6>Shipping Area</h6>
            <p>
              Currently, Brew Your Brand - Brand Audit Kit ships only within
              India. Orders placed for international shipping addresses will not
              be processed.
            </p>

            <h6>Delivery Time Frame</h6>
            <p>
              Delivery times may vary based on the shipping address and the
              availability of routes. Estimated delivery times will be provided
              at checkout, but actual delivery may vary based on logistical
              factors.
            </p>

            <h6>Shipping Costs</h6>
            <p>
              Shipping costs are calculated based on the shipping address and
              the delivery option chosen at checkout. Any additional charges
              will be displayed before the purchase is completed.
            </p>

            <h6>Order Tracking</h6>
            <p>
              Once your order is shipped, you will receive a tracking number (if
              available) to monitor the status of your delivery. Tracking
              options may vary depending on the shipping service used.
            </p>

            <h6>Damaged or Missing Items</h6>
            <p>
              If any items in your kit arrive damaged or are missing, please
              notify us at <a href="mailto:support@brewyourbrand.in"> support@brewyourbrand.in</a> within 7 days of delivery.
              We will work with you to arrange a replacement for any verified
              issues.
            </p>

            <h6> Contact Information</h6>
            <p>
              If any items in your kit arrive damaged or are missing, please
              notify us at <a href="mailto:support@brewyourbrand.in"> support@brewyourbrand.in</a> within 7 days of delivery. We
              will work with you to arrange a replacement for any verified
              issues.
            </p>

            <p>
              For questions or issues regarding shipping and delivery, please
              contact us at <a href="mailto:support@brewyourbrand.in">support@brewyourbrand.in</a> 
            </p>
          </div>
        </div>
      </section>
      <BybFooter/>

    </>
  );
}

export default BybShipDelivery;
